<template>
  <router-link :to="{ name: 'clusters.show', params: { cluster_id: cluster.id } }">
    <div class="row">
      <div class="col-12 col-lg-8">
        <p class="text-truncate">
          <span class="strong">{{ cluster.name }}</span>
          <small class="text-muted">({{ cluster.id }})</small>
        </p>
      </div>
      <div class="col-6 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Applications:</span>
          {{ cluster.applications ? cluster.applications.length : 0 }}
        </p>
      </div>
      <div class="col-6 col-lg-2 justify-content-lg-end">
        <span class="status" :class="cluster.production ? 'status-primary' : 'status-warning'">
          {{ cluster.production ? 'Production' : 'Staging' }}
        </span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    cluster: {
      required: true,
      type: Object
    }
  }
}
</script>
